import createClient from "openapi-fetch";

import { getConfig } from "../config";
import type { paths } from "./schema";

// One host for every clinic: login names the clinic by the `subdomain` in its body, not the Host.
const baseUrl = getConfig().apiUrl;

export const apiClient = createClient<paths>({ baseUrl });
